import { Box, Skeleton, Stack, Table, TableContainer, Tooltip, useTheme } from "@mui/material";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import LinkIcon from "../../../icons/LinkIcon";

const rows = [...Array(15)].map(() => ({
  skeleton: (
    <Skeleton
      variant="rounded"
      height={20}
      sx={{ backgroundColor: "#EBEBEB", width: "100%" }}
    />
  )
}));

export const InsightTableSkeleton = () => (
  <Box>
    <TableContainer>
      <Table
        sx={{ minWidth: 250, tableLayout: "fixed" }}
        aria-labelledby="tableTitle"
        // size={dense ? 'small' : 'medium'}
        size="small"
      >
        <TableHead component={Paper}>
          <TableRow>
            <TableCell>Created By</TableCell>
            <TableCell align="left">Date</TableCell>
            <TableCell align="center">Interviewee</TableCell>
            <TableCell align="center">Priority</TableCell>
            <TableCell align="center">Quote</TableCell>
            <TableCell align="center">Comment</TableCell>
            <TableCell align="center">
              <LinkIcon  sx={{
              color: "inherit",
              fill: "none",
            }}
            strokeWidth="1.2"/>
            </TableCell>
            <TableCell align="center">Tags</TableCell>
            <TableCell align="center">source</TableCell>
          </TableRow>
        </TableHead>
        <TableBody component={Paper}>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell align="center">
                <Skeleton
                  variant="circular"
                  height={50}
                  width={50}
                  sx={{ backgroundColor: "#EBEBEB", width: "100%" }}
                />
              </TableCell>
              <TableCell align="left">{row.skeleton}</TableCell>
              <TableCell align="center">{row.skeleton}</TableCell>
              <TableCell align="center">{row.skeleton}</TableCell>
              <TableCell align="center">{row.skeleton}</TableCell>
              <TableCell align="center">{row.skeleton}</TableCell>
              <TableCell align="center">{row.skeleton}</TableCell>
              <TableCell align="center">{row.skeleton}</TableCell>
              <TableCell align="center">{row.skeleton}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

export const InsightPageTableSkeleton = ()=>{
 const theme = useTheme()

  return (
    <Box sx={{ mt: 1 }}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Stack>
          <Skeleton variant="rounded" width={200} height={30} />
        </Stack>
        <Stack direction={"row"} gap={1}>
          <Skeleton variant="rounded" width={50} height={30} />
          <Skeleton variant="rounded" width={50} height={30} />
          <Skeleton variant="rounded" width={50} height={30} />
        </Stack>
      </Stack>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "white",
          padding: "10px",
          mt: "13px",
          border: `1px solid ${theme?.custom?.borderGrey}`,
          borderRadius: "2px",
          height: "calc(100vh - 129px)",
          overflowY: "auto",
        }}
      >
        <InsightTableSkeleton />
      </Box>
    </Box>
  );
}

export const InsightDetailsSkeleton = () => (
  <Tooltip title="Select an Insight to show detail">
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <div
          style={{
            display: "flex",
            borderBottom: `1px solid #cccccc`,
            paddingBottom: "10px"
          }}
        >
          <Skeleton
            variant="circular"
            animation={false}
            width={40}
            height={40}
            sx={{ backgroundColor: "#cccccc" }}
          />
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <Skeleton
              variant="rounded"
              animation={false}
              width={85}
              height={20}
              sx={{ marginLeft: "10px", backgroundColor: "#cccccc" }}
            />
            <Skeleton
              variant="rounded"
              animation={false}
              width={50}
              height={14}
              sx={{ marginLeft: "10px" }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            flexWrap: "wrap",
            width: "100%",
            marginTop: "10px"
          }}
        >
          <Skeleton
            variant="rounded"
            animation={false}
            width={60}
            height={24}
            sx={{ marginBottom: "5px", backgroundColor: "#cccccc" }}
          />
          <Skeleton
            variant="rounded"
            animation={false}
            width={"96%"}
            height={24}
            sx={{ marginLeft: "5px", borderRadius: "4px 0px 0px 4px" }}
          />
          <Skeleton
            variant="rounded"
            animation={false}
            width={"96%"}
            height={24}
            sx={{ marginLeft: "5px", borderRadius: "0px" }}
          />
          <Skeleton
            variant="rounded"
            animation={false}
            width={"96%"}
            height={24}
            sx={{ marginLeft: "5px", borderRadius: "0px 4px 4px 0px" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            flexWrap: "wrap",
            width: "100%"
          }}
        >
          <Skeleton
            variant="rounded"
            animation={false}
            width={70}
            height={24}
            sx={{ marginBottom: "5px", backgroundColor: "#cccccc" }}
          />
          <Skeleton
            variant="rounded"
            animation={false}
            width={"96%"}
            height={24}
            sx={{ marginLeft: "5px", borderRadius: "4px 0px 0px 4px" }}
          />
          <Skeleton
            variant="rounded"
            animation={false}
            width={"96%"}
            height={24}
            sx={{ marginLeft: "5px", borderRadius: "0px 4px 4px 0px" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            flexWrap: "wrap",
            width: "100%"
          }}
        >
          <Skeleton
            variant="rounded"
            animation={false}
            width={50}
            height={24}
            sx={{ marginBottom: "5px", backgroundColor: "#cccccc" }}
          />
          <div style={{ display: "flex" }}>
            <Skeleton
              variant="rounded"
              animation={false}
              width={45}
              height={24}
              sx={{ marginLeft: "5px" }}
            />
            <Skeleton
              variant="rounded"
              animation={false}
              width={45}
              height={24}
              sx={{ marginLeft: "5px" }}
            />
            <Skeleton
              variant="rounded"
              animation={false}
              width={68}
              height={24}
              sx={{ marginLeft: "5px" }}
            />
            <Skeleton
              variant="rounded"
              animation={false}
              width={48}
              height={24}
              sx={{ marginLeft: "5px" }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            flexWrap: "wrap",
            width: "100%"
          }}
        >
          <Skeleton
            variant="rounded"
            animation={false}
            width={60}
            height={24}
            sx={{ marginBottom: "5px", backgroundColor: "#cccccc" }}
          />
          <div style={{ display: "flex" }}>
            <Skeleton
              variant="circular"
              animation={false}
              width={24}
              height={24}
              sx={{ marginLeft: "5px" }}
            />
            <Skeleton
              variant="rounded"
              animation={false}
              width={"75%"}
              height={24}
              sx={{ marginLeft: "5px" }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <Skeleton
              variant="circular"
              animation={false}
              width={24}
              height={24}
              sx={{ marginLeft: "5px" }}
            />
            <Skeleton
              variant="rounded"
              animation={false}
              width={"70%"}
              height={24}
              sx={{ marginLeft: "5px" }}
            />
          </div>
        </div>
      </div>
    </>
  </Tooltip>
);
